import { gql } from "@apollo/client";

export const SIGNUP = gql`
  mutation CreateClient($input: InputCreateClient!) {
    CreateClient(input: $input) {
      id
    }
  }
`;
